<template>
    <div>
      <!-- Il messaggio di crediti verrà visualizzato nella console quando il componente viene incorporato -->
    </div>
</template>

<script>
export default {
  created() {
    console.log("Crediti: Realizzato da [matteosantoro.dev]");
  },
};
</script>